import { Box, Grid, Typography } from "@mui/material";
import { Bar, BarChart, CartesianGrid, Legend, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { PericiaMetricDTO } from "../../../../entities/pericia/model/dto";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { LoadingButton } from "@mui/lab";
import {
  AVERAGE_FINISHED_ITA,
  CHART_FINISHED_ITA,
  PERICIAS_FINISHED_ITA,
  TIME_ITA,
  TOTAL_FINISHED_ITA
} from "../../../../shared/constants/metric-chart-texts";

interface Props {
  metrics: PericiaMetricDTO[];
  finishedInfo: FinishedInfo;
  timeFrame: string;
  startDate: string;
  endDate: string;
}

interface FinishedInfo {
  totalFinished: number;
  average: string;
}

const NUOVAUTO_LOGO = require("../../../../assets/nuovauto.png");

export const FinishedBarchart = ({ metrics, finishedInfo, timeFrame, startDate, endDate }: Props) => {
  const time = timeFrame.split("-")[1];
  const unit = timeFrame.split("-")[0];

  const chartRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => chartRef.current
  });

  return (
    <>
      <Grid container spacing={2} ref={chartRef} mt={5}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box component="img" src={NUOVAUTO_LOGO} ml={5} mb={2} sx={{ width: "320px" }} />
          <Box>
            <Typography variant="h4" ml={5}>
              {`${CHART_FINISHED_ITA} (${startDate} - ${endDate})`}
            </Typography>
          </Box>
        </Box>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ResponsiveContainer width="100%" height={550}>
            <BarChart
              width={500}
              height={300}
              data={metrics}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="finished" name={PERICIAS_FINISHED_ITA} fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
        <Box ml={5} mt={5}>
          <Typography variant="body1">
            {TOTAL_FINISHED_ITA}: {finishedInfo.totalFinished}
          </Typography>
          <Typography variant="body1">
            {AVERAGE_FINISHED_ITA}: {`${finishedInfo.average}/${unit}`}
          </Typography>
        </Box>
        <Box ml={5} mb={5} mt={5}>
          <Typography variant="body1">
            {TIME_ITA}: {`${time} ${unit}`}
          </Typography>
        </Box>
      </Grid>
      <LoadingButton variant="outlined" onClick={handlePrint}>
        print
      </LoadingButton>
    </>
  );
};
